import { Component, lazy, Suspense } from "react";
import {
  arrayOf,
  bool,
  func,
  number,
  object,
  oneOfType,
  shape,
  string,
} from "prop-types";

import { routes } from "../../constants";

const SelectFilesDesktopDrawer = lazy(
  () => import("../select-files/components/SelectFiles.desktop.drawer")
);
const SelectFilesMobileDrawer = lazy(
  () => import("../select-files/components/SelectFiles.mobile.drawer")
);

class CompareDrawer extends Component {
  constructor(props) {
    super(props);

    this.getDrawerComponent = this.getDrawerComponent.bind(this);
    this.formatTrackingEventLabel = this.formatTrackingEventLabel.bind(this);
    this.removeListing = this.removeListing.bind(this);

    this.DrawerComponents = {};
  }

  /**
   * Format tracking event label
   * @param {object} listing
   * @public
   */
  formatTrackingEventLabel(listing) {
    let labelParts = [];

    if (!!listing.year) {
      labelParts.push(listing.year);
    }

    if (!!listing.make) {
      labelParts.push(listing.make);
    }

    if (!!listing.make && !!listing.model) {
      labelParts.push("–");
    }

    if (!!listing.model) {
      labelParts.push(listing.model);
    }

    if (!!listing.equipmentId) {
      labelParts.push(`(${listing.equipmentId})`);
    }

    return labelParts.length > 0 ? labelParts.join(" ") : "listing";
  }

  /**
   * Get the correct drawer component for the target device
   * * Uses code React.lazy for code splitting
   * @public
   */
  getDrawerComponent() {
    const { DrawerComponents, removeListing } = this;
    const {
      hasSelectedFiles,
      removeFromComparedListings,
      targetDevice,
      trackEvent,
      ...rest
    } = this.props;

    // Preempt compare drawer if authenticated user
    // is selecting files
    if (hasSelectedFiles) {
      return targetDevice === "desktop" ? (
        <SelectFilesDesktopDrawer />
      ) : (
        <SelectFilesMobileDrawer />
      );
    }

    if (!!targetDevice) {
      if (!DrawerComponents[targetDevice]) {
        DrawerComponents[targetDevice] = lazy(
          () => import(`./components/CompareDrawer.${targetDevice}`)
        );
      }

      const DrawerComponent = DrawerComponents[targetDevice];

      return <DrawerComponent remove={removeListing} {...rest} />;
    } else {
      return null;
    }
  }

  /**
   * Remove Listing
   * @param {object} listing
   */
  removeListing(listing) {
    this.props.removeFromComparedListings(listing.equipmentId);

    if (this.props.trackEvent) {
      this.props.trackEvent({
        category: "Compare",
        action: "Remove",
        label: this.formatTrackingEventLabel(listing),
      });
    }
  }

  render() {
    const { getDrawerComponent } = this;
    const {
      comparedListings: listings,
      hasSelectedFiles,
      location,
    } = this.props;

    return ![routes.compare.path, routes.compile.path].includes(
      location.pathname
    ) &&
      (!!listings.length || hasSelectedFiles) ? (
      <Suspense fallback={null}>{getDrawerComponent()}</Suspense>
    ) : null;
  }
}

CompareDrawer.propTypes = {
  clearComparedListings: func.isRequired,
  hasSelectedFiles: bool,
  listings: arrayOf(
    shape({
      equipmentId: oneOfType([number, string]),
    })
  ),
  location: object,
  removeFromComparedListings: func.isRequired,
  targetDevice: string,
  trackEvent: func,
};

export default CompareDrawer;
